import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, map, Observable } from 'rxjs';
import { GraphQLComparision } from '../../enums/GraphQLComparision.enum';
import { GraphQLFilter } from '../GraphQl/IGraphQL.service';

@Injectable()
export class GlobalFiltersOptionalService {
  company: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  dateRange: BehaviorSubject<Date[]> = new BehaviorSubject<Date[]>(DateRange());

  SetCompany(company?: any)  {
    this.company.next(company);
  }

  SetDateRange(dates?: Date[]) {
    this.dateRange.next(dates);

  }


  wheres(datasource): Observable<GraphQLFilter[]> {



    var path = null;
    if (datasource == "telepoCdrsPage") path = "companyOrganisationNode";
    if (datasource == "eveCdrsPage") path = "companyOrganisationNode";
    if (datasource == "telepoGroupStatsPage") path = "organisationNode";
    if (datasource == "telepoGroupEveUserStatsPage") path = "organisationNode";

    return combineLatest(this.company, this.dateRange).pipe(map(([company, dateRange]) =>
      [
        {
          path: path,
          comparison: GraphQLComparision.IS_DESCENDANT_OF,
          value: company?.organisationNode ?? '/-99999/'
        },
        {
          path: 'startTime',
          comparison: GraphQLComparision.GREATER_THAN_OR_EQUAL,
          value: dateRange[0] ?? new Date()
        },
        {
          path: 'startTime',
          comparison: GraphQLComparision.LESS_THAN_OR_EQUAL,
          value: dateRange[1] ?? new Date()
        },
      ]));
  }

}

function DateRange() {

  var start = new Date();
  start.setHours(0, 0, 0, 0);

  var end = new Date();
  end.setHours(23, 59, 59, 999);

  return [start, end]
}
